import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
 * {box-sizing: border-box}
`;

export default GlobalStyle;
